module.exports = "/static/media/attachment_Icon.ef1cfdff.svg";